import { CatalogClient } from "@backstage/catalog-client";
import { Entity } from "@backstage/catalog-model";
import {
  discoveryApiRef,
  identityApiRef,
  fetchApiRef,
  useApi,
} from "@backstage/core-plugin-api";
import { handleError } from "../handlers";
import { useCallback, useEffect } from "react";
import { useAsyncFn } from "react-use";

export interface Props {
  tags?: string[];
}

// @TODO: Fix this, should be renamed to useOpsReviewTeams or something
export const useTeams = ({
  tags,
}: Props): {
  loading: boolean;
  error: Error | undefined;
  value: Entity[] | { message: string } | undefined;
  fetchTeams: () => Promise<Entity[] | { message: string }>;
} => {
  const discoveryApi = useApi(discoveryApiRef);
  const identityApi = useApi(identityApiRef);
  const fetchApi = useApi(fetchApiRef);

  const getTeams = useCallback(async () => {
    try {
      const { token } = await identityApi.getCredentials();
      const catalog = new CatalogClient({ discoveryApi, fetchApi });
      const entities = (
        await catalog.getEntities(
          {
            filter: [
              {
                kind: "Group",
              },
            ],
          },
          { token }
        )
      ).items;

      if (tags && tags.includes("ops-review")) {
        const filtered = entities.filter((e: Entity) => {
          if (
            e?.metadata?.annotations?.["kajabi.com/opsreview.exclude"] &&
            e?.metadata?.annotations?.["kajabi.com/opsreview.exclude"] ===
              "true"
          ) {
            return false;
          }
          return true;
        });
        return filtered;
      }

      return entities;
    } catch (err: any) {
      return handleError(err);
    }
  }, [tags, discoveryApi, identityApi, fetchApi]);

  const [state, fetchTeams] = useAsyncFn(async () => {
    return await getTeams();
  }, []);

  useEffect(() => {
    fetchTeams();
  }, [fetchTeams]);

  return {
    loading: state.loading,
    error: state.error,
    value: state?.value,
    fetchTeams,
  };
};
